// Static India state codes + ISO country codes for forms.
// Trimmed to what the UI needs in Phase 2.
export const IN_STATES = [
    ["AN", "Andaman & Nicobar"],
    ["AP", "Andhra Pradesh"],
    ["AR", "Arunachal Pradesh"],
    ["AS", "Assam"],
    ["BR", "Bihar"],
    ["CH", "Chandigarh"],
    ["CG", "Chhattisgarh"],
    ["DN", "Dadra & Nagar Haveli and Daman & Diu"],
    ["DL", "Delhi"],
    ["GA", "Goa"],
    ["GJ", "Gujarat"],
    ["HR", "Haryana"],
    ["HP", "Himachal Pradesh"],
    ["JK", "Jammu & Kashmir"],
    ["JH", "Jharkhand"],
    ["KA", "Karnataka"],
    ["KL", "Kerala"],
    ["LD", "Lakshadweep"],
    ["LA", "Ladakh"],
    ["MP", "Madhya Pradesh"],
    ["MH", "Maharashtra"],
    ["MN", "Manipur"],
    ["ML", "Meghalaya"],
    ["MZ", "Mizoram"],
    ["NL", "Nagaland"],
    ["OD", "Odisha"],
    ["PY", "Puducherry"],
    ["PB", "Punjab"],
    ["RJ", "Rajasthan"],
    ["SK", "Sikkim"],
    ["TN", "Tamil Nadu"],
    ["TG", "Telangana"],
    ["TR", "Tripura"],
    ["UP", "Uttar Pradesh"],
    ["UK", "Uttarakhand"],
    ["WB", "West Bengal"],
];

export const COUNTRIES = [
    ["IN", "India"],
    ["GB", "United Kingdom"],
    ["AE", "United Arab Emirates"],
    ["US", "United States"],
    ["SG", "Singapore"],
];

export const FUEL_TYPES = ["petrol", "diesel", "cng", "lpg", "electric", "hybrid"];
export const TRANSMISSIONS = ["manual", "automatic", "amt", "cvt", "dct"];
export const CUSTOMER_TYPES = ["individual", "business", "fleet"];

export function formatReg(s) {
    if (!s) return "";
    const n = String(s).toUpperCase().replace(/[^A-Z0-9]/g, "");
    // Try Indian classic: SSDD AA NNNN (state + district + series + number)
    if (/^[A-Z]{2}\d{1,2}[A-Z]{1,3}\d{1,4}$/.test(n)) {
        return n.replace(/^([A-Z]{2})(\d{1,2})([A-Z]{1,3})(\d{1,4})$/, "$1 $2 $3 $4");
    }
    return n;
}

export function normalizeReg(s) {
    return String(s || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
}
